document.addEventListener('DOMContentLoaded', function() {
    var checkoutButton = document.querySelector('.cart__checkout');
    
    if (checkoutButton) {
        checkoutButton.addEventListener('click', function() {
            localStorage.setItem('fromCheckout', 'true');
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    // Check if the user came from the checkout page
    if (localStorage.getItem('fromCheckout') === 'true') {
        // Remove the flag
        localStorage.removeItem('fromCheckout');
        // Reload the page
        window.location.reload();
    }
});

customElements.whenDefined('product-info').then(function() {
    var ProductInfo = customElements.get('product-info');
    var originalUpdateButtonPrice = ProductInfo.prototype.updateButtonPrice;

    if (!originalUpdateButtonPrice || originalUpdateButtonPrice.wcpPatched) return;

    ProductInfo.prototype.updateButtonPrice = function() {
        var variant = this.getSelectedVariant(this);
        var wcpJsonElement = variant && document.getElementsByClassName('wcp_json_' + variant.id)[0];

        if (!wcpJsonElement) return originalUpdateButtonPrice.apply(this, arguments);

        var wcpData;
        try {
            wcpData = JSON.parse(wcpJsonElement.textContent);
        } catch (error) {
            console.warn('Unable to parse WCP product data.', error);
            return originalUpdateButtonPrice.apply(this, arguments);
        }

        var wcpVariant = wcpData.variants && wcpData.variants.find(function(item) {
            return item.id === variant.id;
        });

        if (!wcpVariant) return originalUpdateButtonPrice.apply(this, arguments);

        variant.price = wcpVariant.price;
        variant.compare_at_price = wcpVariant.compare_at_price;

        var hadOwnGetSelectedVariant = Object.prototype.hasOwnProperty.call(this, 'getSelectedVariant');
        var ownGetSelectedVariant = this.getSelectedVariant;
        this.getSelectedVariant = function() {
            return variant;
        };

        try {
            return originalUpdateButtonPrice.apply(this, arguments);
        } finally {
            if (hadOwnGetSelectedVariant) {
                this.getSelectedVariant = ownGetSelectedVariant;
            } else {
                delete this.getSelectedVariant;
            }
        }
    };

    ProductInfo.prototype.updateButtonPrice.wcpPatched = true;
});
